<template>
    <div id="new-bitrix-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper d-none">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-form-item
                        :validate-status="getErrorStatus('channelName')"
                        :help="getErrorMessage('channelName')"
                    >
                        <a-input
                            v-model="form.channelName"
                            :placeholder="$t('whatsappChannel.channelName')"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>
                <div class="input-wrapper">
                    <label>{{ $t("message.yourBitrix24Domain") }}</label>
                    <a-input addon-before="https://" v-model="form.domain" v-validate="'required'" name="domain" />
                </div>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">{{ $t("message.cancel") }}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSubmit" type="primary" :disabled="loading">
                    {{ $t("mail.connect") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import CONFIG from "../../../../config/config";
import { copyText2Clipboard } from "../../../../utils/utils";
import { socketMessageStream } from "../../../../utils/socketStream";
import { first, map, timeout } from "rxjs/operators";

export default {
    name: "CreateBitrixChannel",
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },
    components: {},
    data() {
        return {
            form: {
                channelName: "Bitrix24",
                domain: "",
            },
            loading: false,
            clone: _.cloneDeep(this.channel),
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site?._id,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        handleCancel() {
            this.$emit("cancel");
        },
        getRedirectURL() {
            return `${CONFIG.SOCKET_URL}/webhook/oauth2/bitrix24`;
        },
        startOauth() {
            this.loading = true;
            const redirectUrl = this.getRedirectURL();
            const CLIENT_ID = "app.668bfe70b5b9a8.88704673";

            const url = `https://${this.form.domain}/oauth/authorize?response_type=code&client_id=${CLIENT_ID}&state=${this.siteId}&redirect_uri=${redirectUrl}`;
            this.listenSocket();
            this.window = window.open(url, "_blank");
        },
        listenSocket() {
            socketMessageStream
                .pipe(
                    first((x) => x.cmd === "bitrix_callback_response"),
                    map((x) => x.data),
                    timeout(30000)
                )
                .toPromise()
                .then(async (data) => {
                    const payload = {
                        domain: this.form.domain,
                        code: data.code,
                        state: data.state,
                        member_id: data.member_id,
                        scope: data.scope,
                        server_domain: data.server_domain,
                        tokenInfo: data.tokenInfo,
                    };
                    await this.completeCreateChannel(payload);
                    this.loading = false;
                    this.window.close();
                    this.$message.success(this.$t("message.bitrix24ConnectedSucs"));
                })
                .catch((err) => {
                    this.loading = false;
                    this.window.close();
                    this.$message.error(this.$t("message.failedToConnectBitrix24"));
                });
        },
        completeCreateChannel(payload) {
            const data = {
                payload,
                type: "bitrix",
                name: "Bitrix24",
            };
            return this.createChannel(data)
                .then(() => {
                    this.$message.success(this.$t("message.channelCreatedSuccessfully"));
                    this.$emit("ok");
                })
                .catch((err) => {
                    this.$message.error(this.$t("message.failedToCreateChannel"));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSubmit() {
            this.submitClicked = true;
            if (this.form.channelName.length < 1) {
                this.$refs.channelName.focus();
                return;
            } else {
                const isValid = true;
                if (isValid) {
                    this.startOauth();
                }
            }
        },
    },
    mounted() {},
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#new-bitrix-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .webhook-info {
            display: flex;
            gap: 5px;
            justify-content: center;
            padding: 5px;
            overflow-wrap: anywhere;

            .anticon {
                &:hover {
                    color: var(--color-text-info-hover);
                }
            }
        }

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
            height: 75px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>

<style lang="scss">
.new-sms-postacell {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
